<div class="container">

  <div class="hero">
    <div class="hero-image"></div>
  </div>

  <div class="main">
    <table cellspacing="0" cellpadding="0">
      <thead>
        <tr>
          <td>&nbsp;</td>
          <td class="center">Short Clips</td>
          <td class="center">Extended Clips</td>
          <td class="center">Full Episodes</td>
          <td class="center">Live Broadcasts</td>
          <td class="center">Podcasts</td>
        </tr>
      </thead>
      <tbody>
        @for (row of table; track row) {
          <tr>
            <td>
              <a target="_blank" [attr.href]="row.url">
                <div role="img" class="platform-image" [attr.aria-label]="row.name" [responsiveBackgroundImage]="row.image"></div>
              </a>
            </td>
            <td class="center">
              {{ display[row.short_clips] }}
            </td>
            <td class="center">
              @if (locked(row.extended_clips)) {
                <tyt-plus-tag audience="visitor" state="locked"></tyt-plus-tag>
              }
              {{ display[row.extended_clips] }}
            </td>
            <td class="center">
              @if (locked(row.full_episodes)) {
                <tyt-plus-tag audience="visitor" state="locked"></tyt-plus-tag>
              }
              {{ display[row.full_episodes] }}
            </td>
            <td class="center">
              @if (locked(row.live_broadcasts)) {
                <tyt-plus-tag audience="visitor" state="locked"></tyt-plus-tag>
              }
              {{ display[row.live_broadcasts] }}
            </td>
            <td class="center">
              @if (locked(row.podcasts)) {
                <tyt-plus-tag audience="visitor" state="locked"></tyt-plus-tag>
              }
              {{ display[row.podcasts] }}
            </td>
          </tr>
        }
        @if (notMember) {
          <tr class="center">
            <td colspan="6">@if (billingEnabled) {
              <a href="{{joinUrl}}">
                <tyt-form-submit-button>Become a Member</tyt-form-submit-button>
              </a>
            }</td>
          </tr>
        }
      </tbody>
    </table>
  </div>

</div>
